<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="续约"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="my-at">我的预约</div>
      <div class="at-show-time">{{ showTime }}</div>
      <div class="at-address">{{ typeName }} {{ buildingNo }}{{ roomNo }}</div>
      <div class="next-quantum-parent">
        <div class="next-quantum-hint">今日下一预约：</div>
        <div class="next-quantum">{{ nextTimeQuantum }}</div>
      </div>
      <div v-if="canContinueTimeQuantum.length >= 2" class="at-parent">
        <div class="at-quantum-parent">
          <div class="at-quantum-hint">续约时段：</div>
          <div class="at-quantum">
            {{ canContinueTimeQuantum[startIndex].time }}-{{
              canContinueTimeQuantum[endIndex].time
            }}
          </div>
        </div>
        <div class="imaginary-line"></div>
        <div class="at-subtract-parent">
          <div class="at-hint">续约时长（小时）</div>
          <div class="at-subtract" @click="atSubtract">
            <div class="at-subtract-1"></div>
          </div>
          <!-- <div class="at-time">{{(endIndex - startIndex) * 5 / 10}}</div> -->
          <div class="at-time">{{ continueResult }}</div>
          <div class="at-plus" @click="atPlus">
            <div class="at-plus-1"></div>
            <div class="at-plus-2"></div>
          </div>
        </div>
        <div class="continue-at" @click="continueAt">续 约</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'
import { Toast, Dialog } from 'vant'
export default {
  data () {
    return {
      bookId: '',
      roomId: '',
      buildingNo: '',
      roomNo: '',
      typeName: '',
      duration: '',
      startTime: null,
      endTime: null,
      showTime: '',
      address: '',
      nextTimeQuantum: '',
      canContinueTimeQuantum: [],
      startIndex: -1,
      endIndex: -1,

      minLen: 0,
      continueResult: 0,
      getOptions: {}
    }
  },
  mounted () {
    console.log('续约详情接受', this.$route.query)
    const allConfigs = JSON.parse(localStorage.getItem(common.keyConfigInfo))
    this.allConfigs = allConfigs
    this.minLen = (this.allConfigs && this.allConfigs.base_span) ? this.allConfigs.base_span : 30
    // console.log(this.minLen)
    // const option = this.$route.query
    this.getOptions = this.$route.query
    let startTime = decodeURIComponent(this.getOptions.startTime)
    let endTime = decodeURIComponent(this.getOptions.endTime)
    if (utils.judgeClient() !== constant.judgeClientType.Android) {
      startTime = startTime.replace(/-/g, '/')
      endTime = endTime.replace(/-/g, '/')
    }
    startTime = new Date(startTime)
    endTime = new Date(endTime)
    const showTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
    this.bookId = this.getOptions.bookId
    this.roomId = this.getOptions.roomId
    this.buildingNo = this.getOptions.buildingNo
    this.duration = this.getOptions.duration
    this.roomNo = this.getOptions.roomNo
    this.typeName = this.getOptions.typeName

    this.startTime = startTime
    this.endTime = endTime
    this.showTime = showTime
    this.getPianoOneDayReserved()
  },
  computed: {

  },
  methods: {
    getPianoOneDayReserved () {
      Toast.loading({
        message: '请稍后...',
        forbidClick: true
      })
      const that = this
      const para = {

        room_id: that.getOptions.roomId,
        book_date: utils.formatTimeYMDInterval(that.startTime, '-')
      }
      api
        .axiosRequest(api.urlList.getPianoOneDayReserved, para)
        .then((res) => {
          Toast.clear()
          // console.log(res, typeof res.code, res.code, typeof common.resCode.OK)
          if (res.code === common.resCode.OK) {
            const appointmentList = []
            for (let f = 0; f < res.list.length; ++f) {
              const c = res.list[f]
              if (utils.judgeClient() !== constant.judgeClientType.Android) {
                c.begin_time = c.begin_time.replace(/-/g, '/').replace(/T/, ' ')
                c.end_time = c.end_time.replace(/-/g, '/').replace(/T/, ' ')
              }
              const start = new Date(c.begin_time)
              const end = new Date(c.end_time)

              appointmentList.push({
                startTotalMinutes: start.getHours() * 60 + start.getMinutes(),
                endTotalMinutes: end.getHours() * 60 + end.getMinutes()
              })
            }

            const curTimeTotalMinutes = that.endTime.getHours() * 60 + that.endTime.getMinutes()
            const timeQuantumList = that.getTimeQuantumList(appointmentList)
            const canContinueTimeQuantum = []
            for (const i in timeQuantumList) {
              if (!timeQuantumList[i].overdueRight && timeQuantumList[i].totalMinutes >= curTimeTotalMinutes) {
                canContinueTimeQuantum.push(timeQuantumList[i])
              } else {
                if (canContinueTimeQuantum.length > 0) {
                  break
                }
              }
            }
            if (canContinueTimeQuantum.length >= 2) {
              that.startIndex = 0
              that.endIndex = 1
              that.continueResult = that.transformationHour(that.minLen / 60)
              that.nextTimeQuantum = canContinueTimeQuantum[0].time + '-' + canContinueTimeQuantum[1].time
              that.canContinueTimeQuantum = canContinueTimeQuantum
            } else {
              Toast.fail('下一时间段已被占用，已无法续约')
              // wx.showModal({
              //   title: '提示',
              //   content: '下一时间段已被占用，已无法续约',
              //   showCancel: false,
              //   success (res) {
              //     wx.navigateBack({})
              //   }
              // })
            }
          } else {
            utils.judgeBackMsg(res)
            this.onClickLeft()
          }
        })
        .catch((e) => {
          console.log('error log:', e)

          this.onClickLeft()
        })
    },
    continueAt () {
      Toast.loading({
        message: '提交中...',
        forbidClick: true
      })

      const canContinueTimeQuantum = this.canContinueTimeQuantum
      const ymd = utils.formatTimeYMDInterval(this.startTime, '-')
      const startTime = ymd + ' ' + canContinueTimeQuantum[this.startIndex].time + ':00'
      const endTime = ymd + ' ' + canContinueTimeQuantum[this.endIndex].time + ':00'
      const para = {

        room_id: this.roomId,
        book_date: ymd,
        begin_time: startTime,
        end_time: endTime
      }
      api
        .axiosRequest(api.urlList.continuePiano, para)
        .then((res) => {
          Toast.clear()
          // console.log(res, typeof res.code, res.code, typeof common.resCode.OK)
          if (res.code === common.resCode.OK) {
            Dialog.alert({
              title: '提示',
              message: '续约成功'
            }).then(() => {
              // on close
              this.onClickLeft()
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: res.msg
            }).then(() => {
              // on close

              this.getPianoOneDayReserved()
            })
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    atSubtract () {
      if (this.endIndex > 1) {
        const endIndex = this.endIndex - 1

        this.endIndex = endIndex
        this.continueResult = this.transformationHour((endIndex - this.startIndex) * this.minLen / 60)
      } else {
        Toast.fail('已经是最小预约时间了')
      }
    },
    atPlus () {
      if (this.endIndex < this.canContinueTimeQuantum.length - 1) {
        const endIndex = this.endIndex + 1

        this.endIndex = endIndex
        this.continueResult = this.transformationHour((endIndex - this.startIndex) * this.minLen / 60)
      } else {
        Toast.fail('下一时间段已被占用或不可预约')
      }
    },
    transformationHour (allhour) {
      if (allhour) {
        const hour = Number.parseInt(allhour)
        const minute = Math.round(allhour % 1 * 60)
        allhour = ''

        if (hour > 0) {
          allhour += hour + '小时'
        }
        if (minute > 0) {
          allhour += minute + '分钟'
        }
        if (!allhour) {
          allhour = 0
        }
      } else {
        allhour = 0
      }
      return allhour
    },
    getTimeQuantumList (appointmentList) {
      // const week = that.seltDate.getDay()
      // const week = 4
      const allconfigs = utils.refreshConfigData()
      console.log('切换日期查询数据获得当天的开放时间', allconfigs)
      // localStorage.setItem('configInfo', JSON.stringify(allconfigs))
      api.setConfig(JSON.stringify(allconfigs))
      this.allConfigs = allconfigs
      const configStartTime = this.allConfigs.begin_time
      const configEndTime = this.allConfigs.end_time

      const start = configStartTime.split(':')
      const startHour = parseInt(start[0])
      const startMinutes = parseInt(start[1])
      const startTotalMinutes = startHour * 60 + startMinutes

      const end = configEndTime.split(':')
      const endHour = parseInt(end[0])
      const endMinutes = parseInt(end[1])
      const endTotalMinutes = endHour * 60 + endMinutes

      // 每段时间长度 分钟
      const eachLength = (this.allConfigs && this.allConfigs.base_span) || 30
      // 整个总时长
      const totalTime = endTotalMinutes - startTotalMinutes
      // 去除多余的时间，计算整个总时长可分成的段数
      const timeQuantumNum = (totalTime - totalTime % eachLength) / eachLength
      const timeQuantumList = []
      // 取时间节点要比时间段数多一
      let count = 0
      while (count <= timeQuantumNum) {
        const nodeTotalMinutes = startTotalMinutes + (count * eachLength)
        let nodeMinutes = nodeTotalMinutes % 60
        let nodeHour = (nodeTotalMinutes - nodeMinutes) / 60
        nodeMinutes = this.formatNumber(nodeMinutes)
        nodeHour = this.formatNumber(nodeHour)
        timeQuantumList.push({
          showTime: nodeHour + ' : ' + nodeMinutes,
          time: nodeHour + ':' + nodeMinutes,
          totalMinutes: nodeTotalMinutes,
          overdueLeft: false,
          overdueRight: false
        })
        ++count
      }
      for (let c = 0; c < timeQuantumList.length; ++c) {
        const startD = timeQuantumList[c]
        if (c === 0) {
          startD.overdueLeft = true
        }
        if (timeQuantumList.length - 1 === c) {
          startD.overdueRight = true
          break
        }
        for (let f = 0; f < appointmentList.length; ++f) {
          const g = appointmentList[f]
          const endD = timeQuantumList[c + 1]
          if (g.startTotalMinutes < endD.totalMinutes && g.endTotalMinutes > startD.totalMinutes) {
            startD.overdueRight = true
            endD.overdueLeft = true
            break
          }
        }
      }
      return timeQuantumList
    },
    formatNumber: function (n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
}
.my-at {
  font-size: 1.375rem;
  color: #1a91ff;
  margin-left: 0.875rem;
  margin-top: 1.125rem;
}
.at-show-time {
  font-weight: 550;
  font-size: 1rem;
  color: #333333;
  margin-left: 0.875rem;
  margin-top: 1.375rem;
}
.at-address {
  font-weight: 550;
  font-size: 0.875rem;
  color: #666;
  margin-left: 0.875rem;
  margin-top: 0.375rem;
}
.next-quantum-parent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0.9375rem 0.875rem 0 0.875rem;
  box-sizing: border-box;
  padding-left: 0.6875rem;
  padding-right: 0.6875rem;

  height: 1.3125rem;
  background: rgba(245, 245, 245, 1);
}
.next-quantum-hint {
  font-size: 0.875rem;
  color: #666;
}
.next-quantum {
  font-size: 0.875rem;
  color: #666;
}
.at-parent {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 0px 5px 0px rgba(1, 1, 1, 0.1);
}
.at-quantum-parent {
  margin-left: 1.5625rem;
  margin-right: 1.5625rem;
  height: 4.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.at-quantum-hint {
  font-weight: 550;
  font-size: 1.25rem;
  color: #666;
}
.at-quantum {
  font-weight: 550;
  font-size: 1.25rem;
  color: #1a91ff;
}
.imaginary-line {
  margin-left: 1.5625rem;
  margin-right: 1.5625rem;
  height: 0.0625rem;
  background-image: linear-gradient(
    to right,
    #ccc 0%,
    #ccc 50%,
    transparent 50%
  );
  background-size: 0.5rem 0.0625rem;
  background-repeat: repeat-x;
}
.at-subtract-parent {
  margin-left: 1.5625rem;
  margin-right: 1.5625rem;
  height: 4.6875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.at-hint {
  flex-grow: 1;
  font-size: 1rem;
  color: #333;
}
.at-time {
  width: 6.5625rem;
  font-size: 0.9375rem;
  text-align: center;
  color: #333;
}
.continue-at {
  height: 3.75rem;
  line-height: 3.75rem;
  text-align: center;
  background-color: #ff9d00;
  font-weight: 550;
  font-size: 1.25rem;
  color: #fff;
}
.at-subtract {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 1.375rem;
  height: 1.375rem;
  border-radius: 0.0625rem;
  border: 0.0625rem solid #1a91ff;
}
.at-subtract-1 {
  height: 0.0625rem;
  width: 0.875rem;
  background-color: #1a91ff;
}
.at-plus {
  position: relative;
  width: 1.375rem;
  height: 1.375rem;
  border-radius: 0.0625rem;
  background-color: #1a91ff;
}
.at-plus-1 {
  position: absolute;
  height: 0.0625rem;
  width: 0.875rem;
  left: 0.25rem;
  top: 0.625rem;
  background-color: #fff;
}
.at-plus-2 {
  position: absolute;
  height: 0.875rem;
  width: 0.0625rem;
  left: 0.625rem;
  top: 0.25rem;
  background-color: #fff;
}
</style>
